import { render, staticRenderFns } from "./ddcj.vue?vue&type=template&id=dcef3f24&scoped=true&"
import script from "./ddcj.vue?vue&type=script&lang=js&"
export * from "./ddcj.vue?vue&type=script&lang=js&"
import style0 from "./ddcj.vue?vue&type=style&index=0&id=dcef3f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcef3f24",
  null
  
)

export default component.exports